import type { ColumnDef } from '@tanstack/react-table'
import { format } from 'date-fns/format'

import { SafeFormattedText } from '@/components/ui/safe-formatted-message'
import { InfoQuickView } from '@/components/ui/table/components/InfoQuickView.tsx'
import { Tooltip } from '@/components/ui/tooltip.tsx'
import CancelledIcon from '@/modules/chatting/icons/cancelled.svg'
import type { MassMessage } from '@/modules/chatting/types'
import { getMassMessageStatisticsByMessageIdFx } from '@/modules/chatting/ui/sidebar/mass-messages-statistics/components/models.ts'
import { unsendMessageFx } from '@/modules/chatting/ui/sidebar/mass-messages-statistics/models/priorityMassMessagesStats.ts'

import { UnsendButton } from '../components/UnsendButton.tsx'

export const priorityStatsTableColumns: ColumnDef<MassMessage>[] = [
  {
    accessorKey: 'date',
    header: 'Date & Time',
    size: 200,
    cell: ({ getValue }) => {
      return format(new Date(getValue<string>()), 'MMM dd,yyyy • HH:mm a')
    },
  },
  {
    accessorKey: 'text',
    header: 'Message',
    size: 360,
    enableSorting: false,
    cell: ({ getValue }) => <SafeFormattedText text={getValue<string>()} />,
  },
  {
    accessorKey: 'mediaTypes',
    header: 'Attachment',
    size: 120,
    enableSorting: false,
    cell: ({ getValue }) => {
      const medias = getValue<MassMessage['mediaTypes']>() || {}

      return <div className="flex gap-2">{Object.entries(medias).length}</div>
    },
  },
  {
    accessorKey: 'price',
    header: 'Price',
    size: 120,
    enableSorting: false,
    cell: ({ getValue }) => (getValue() ? `$${getValue()}` : ''),
  },
  {
    id: 'stats',
    header: () => <div className="flex w-full justify-end">Statistics</div>,
    cell: ({ row }) => {
      const processData = () => {
        return getMassMessageStatisticsByMessageIdFx(row.original.id)
      }

      return (
        <InfoQuickView
          data={[]}
          fetchData={processData}
        />
      )
    },
  },
  {
    accessorKey: 'canUnsend',
    header: 'Unsend',
    size: 120,
    enableSorting: false,
    cell: ({ row }) => {
      if (row.original.isCanceled) {
        return (
          <Tooltip
            contentClassName="max-w-[280px]"
            content="This message already canceled"
          >
            <CancelledIcon className="text-secondary-300" />
          </Tooltip>
        )
      }

      return (
        <UnsendButton
          canUnsend={true}
          id={row.original.id}
          sentCount={row.original.sentCount}
          mutationFn={unsendMessageFx}
        />
      )
    },
  },
]
